import React from 'react';
import { ComparisonStatus } from '../../types/apiDiff';
import './CompareVersions.css';

export type FilterKey = 'added' | 'changed' | 'deprecated-removed';

export const FILTER_OPTIONS: { key: FilterKey; label: string }[] = [
    { key: 'added', label: 'Added' },
    { key: 'changed', label: 'Changed' },
    { key: 'deprecated-removed', label: 'Deprecated/Removed' },
];

/** Maps a raw comparison status onto one of the three deterministic filter buckets. */
export function toFilterKey(status: ComparisonStatus): FilterKey {
    if (status === 'added') return 'added';
    if (status === 'changed') return 'changed';
    return 'deprecated-removed';
}

interface ComparisonFilterBarProps {
    activeFilters: Set<FilterKey>;
    onToggle: (key: FilterKey) => void;
    counts: Record<FilterKey, number>;
}

const ComparisonFilterBar: React.FC<ComparisonFilterBarProps> = ({ activeFilters, onToggle, counts }) => {
    return (
        <div className="compare-filter-bar" role="group" aria-label="Filter changes by status">
            {FILTER_OPTIONS.map(({ key, label }) => {
                const isActive = activeFilters.has(key);
                return (
                    <button
                        key={key}
                        type="button"
                        className={`compare-filter-chip${isActive ? ' active' : ''}`}
                        aria-pressed={isActive}
                        onClick={() => onToggle(key)}
                    >
                        {label} ({counts[key] ?? 0})
                    </button>
                );
            })}
        </div>
    );
};

export default ComparisonFilterBar;
